import pluralize from 'pluralize'

const setupPluralize = () => {
  pluralize.addIrregularRule('masterclass', 'masterclasses')
  pluralize.addIrregularRule('Masterclass', 'Masterclasses')
}

export default setupPluralize
